import React from 'react';
import {
  GridOverlay,
  GridRowModel,
  GridColDef,
  DataGridProProps,
  GridValidRowModel,
} from '@mui/x-data-grid-pro';
import {useNavigate} from 'react-router-dom';
import {StickyDataGrid} from '../Common/StickyDataGrid';
import {useTableStyles} from '../useTableStyles';
import {ReviewSummaryFragment} from '../../schema-types/ReviewSummaryFragment';

export const ReviewsTable: React.FC<
  Pick<DataGridProProps, 'sortModel' | 'loading'> & {
    rows: GridRowModel[];
    columns: GridColDef[];
    stage: string;
  }
> = ({rows, columns, stage, loading}) => {
  const classes = useTableStyles();
  const getRowId = React.useCallback((row: GridValidRowModel) => row.id, []);
  const navigate = useNavigate();
  return (
    <StickyDataGrid
      key={stage}
      rows={rows}
      loading={loading}
      columns={columns}
      getRowId={getRowId}
      onRowDoubleClick={(params) => {
        const reviewData = params.row as ReviewSummaryFragment;
        navigate({
          pathname: `/account/${reviewData?.account?.id}/review-journey/${reviewData.id}`,
        });
      }}
      className="search-results"
      sx={{
        ...classes.dataGridContainer,
        ...classes.tableRow,
        ...classes.table,
        ...classes.hideColumnMenu,
      }}
      slots={{
        noRowsOverlay: () => (
          <GridOverlay>You have no reviews in {stage} stage</GridOverlay>
        ),
      }}
    />
  );
};

export default ReviewsTable;
